import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import React, { useState } from "react";
import LearningCardsData from "../../data/LearningTabs.json";
import "./LearningOfferingTab.css";
// import  { makeStyles }  from '@mui/styles';

// const useStyles = makeStyles((theme) => ({
//   activeTab: {
//     '&.Mui-selected': {
//       height: '60px', // Adjust the height of the active tab as needed
//     },
//   },
// }));
const LearningOfferingAccordian = () => {
  const [value, setValue] = useState("1");
  const [expanded, setExpanded] = useState({});
  // const classes = useStyles();
  // const [tabActive, setTabActive] = useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const toggleExpanded = (id) => {
    setExpanded((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }} className="tabs-container">
      <TabContext value={value} indicatorColor="primary">
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            className="tabs-wrapper"
          >
            <Tab
              label="Mandatory Learnings"
              value="1"
              className={value === "1" ? "activeTab" : "tabs"}
            />
            <Tab
              label="Process-based Learning"
              value="2"
              className={value === "2" ? "activeTab" : "tabs"}
            />
            <Tab
              label="Skill-based Learnings"
              value="3"
              className={value === "3" ? "activeTab" : "tabs"}
            />
          </TabList>
        </Box>
        <Box className="tabs-details">
          <TabPanel value="1">
            {LearningCardsData.map((item) =>
              item.learningTab === "Mandatory Learnings" && (
                <div className="learning-wrap accordion-body">
                  <p className="role-based-text">{item.learningContent}</p>
                  <div className="learning-row">
                    {item.learningDetails.map((detail) => (
                      <div className="learning-box">
                        <div className="zoomEffect">
                          <img
                            src={process.env.PUBLIC_URL + detail.courseImg}
                            alt="offerings"
                            className="learn-card-img"
                          />
                        </div>
                        <div className="courseContent">
                          <h3>{detail.courseName}</h3>
                          <p className="decr-text">
                            {expanded[detail.id]
                              ? detail.courseDescription
                              : `${detail.courseDescription.substring(0, 320)} `}
                            {detail.courseDescription.length > 320 && (
                              <button className="readMoreLess" onClick={() => toggleExpanded(detail.id)}>
                                {expanded[detail.id] ? "Read less" : "Read more"}
                              </button>
                            )}
                          </p>
                          {expanded[detail.id] && detail.courseListHead && (
                            <div className="listConteiner">
                              <strong>{detail.courseListHead}</strong>
                              <br />
                              <ul className="tabListContent">
                                {detail.content.map((listItem, index) => (
                                  <li key={index}>{listItem}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        <p className="know-more">
                          <a href={detail.courseLink} target="_blank">
                            Know More
                            <img
                              src="images/Home/knowmore-right-arrow.png"
                              alt="arrow"
                              className="arrow-imgs"
                            />
                          </a>
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )
            )}
            {/* Role based content */}
          </TabPanel>
          <TabPanel value="2">
            {LearningCardsData.map(
              (item) =>
                item.learningTab === "Process based" && (
                  <div className="learning-wrap accordion-body">
                    <p className="role-based-text">{item.learningContent}</p>
                    <div className="learning-row">
                      {item.learningDetails.map((detail) => (
                        <div className="learning-box">
                          <div className="zoomEffect">
                            <img
                              src={process.env.PUBLIC_URL + detail.courseImg}
                              alt="offerings"
                              className="learn-card-img"
                            />
                          </div>
                          <div className="courseContent">
                            <h3>{detail.courseName}</h3>
                            <p className="decr-text">
                              {expanded[detail.id]
                                ? detail.courseDescription
                                : `${detail.courseDescription.substring(0, 320)} `}
                              {detail.courseDescription.length > 320 && (
                                <button className="readMoreLess" onClick={() => toggleExpanded(detail.id)}>
                                  {expanded[detail.id] ? "Read less" : "Read more"}
                                </button>
                              )}
                            </p>
                            {expanded[detail.id] && detail.courseListHead && (
                              <div className="listConteiner">
                                <strong>{detail.courseListHead}</strong>
                                <br />
                                <ul className="tabListContent">
                                  {detail.content.map((listItem, index) => (
                                    <li key={index}>{listItem}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          <p className="know-more">
                            <a href={detail.courseLink} target="_blank">
                              Know More
                              <img
                                src="images/Home/knowmore-right-arrow.png"
                                alt="arrow"
                                className="arrow-imgs"
                              />
                            </a>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )
            )}
            {/* Skill based content */}
          </TabPanel>
          <TabPanel value="3">
            {LearningCardsData.map(
              (item) =>
                item.learningTab === "Skill based" && (
                  <div className="learning-wrap accordion-body">
                    <p className="role-based-text">{item.learningContent}</p>
                    <div className="learning-row">
                      {item.learningDetails.map((detail) => (
                        <div className="learning-box">
                          <div className="zoomEffect">
                            <img
                              src={process.env.PUBLIC_URL + detail.courseImg}
                              alt="offerings"
                              className="learn-card-img"
                            />
                          </div>
                          <div className="courseContent">
                            <h3>{detail.courseName}</h3>
                            <p className="decr-text">
                              {expanded[detail.id]
                                ? detail.courseDescription
                                : `${detail.courseDescription.substring(0, 320)} `}
                              {detail.courseDescription.length > 320 && (
                                <button className="readMoreLess" onClick={() => toggleExpanded(detail.id)}>
                                  {expanded[detail.id] ? "Read less" : "Read more"}
                                </button>
                              )}
                            </p>
                            {expanded[detail.id] && detail.courseListHead && (
                              <div className="listConteiner">
                                <strong>{detail.courseListHead}</strong>
                                <br />
                                <ul className="tabListContent">
                                  {detail.content.map((listItem, index) => (
                                    <li key={index}>{listItem}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          <p className="know-more">
                            <a href={detail.courseLink} target="_blank">
                              Know More
                              <img
                                src="images/Home/knowmore-right-arrow.png"
                                alt="arrow"
                                className="arrow-imgs"
                              />
                            </a>
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )
            )}
            {/* Product based content */}
          </TabPanel>
        </Box>
      </TabContext>
    </Box>
  );
};

export default LearningOfferingAccordian;
